<template>

  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container fluid>

      <b-row>
        <b-col v-if="datosCita != undefined && datosCita != null"
               :cols="datosCita != undefined && datosCita != null?!mostrarBarraBusqueda?11:5:0">
          <cardPerfilPaciente style="margin-left: 80px" :patInfo="datosCita" :mostrarDetalle="!mostrarBarraBusqueda" :datos-contacto-paciente="lstDatosContactoPaciente" @editarDatosContacto="editarDatosContacto"></cardPerfilPaciente>
        </b-col>
        <b-col style="padding: 15px">
          <b-row :style="datosCita!=null?'width: 100%;':'width: 90%;margin: auto;'">
            <b-col cols="12" style="display: flex">

<!--                         Busqueda avanzada        -->
              <div v-if=" mostrarBarraBusqueda && checked"  style="left: 10%; position: relative; width: 95%">
                <br>
                <b-row>
                  <b-col cols="col-sm-12 col-md-3 col-lg-3">
                    <b-form-input
                       style="width: 100%; border: 1px solid #c2e7ff;"
                        v-model="nombre"
                        placeholder=" nombre"
                        type="text"
                        v-on:keypress="esLetra($event)"
                        v-b-tooltip.hover
                        title="Búsqueda básica por nombre del paciente"
                        v-on:keyup.enter="getPatientsV2()"
                        class="input-buscador"
                    ></b-form-input>
                  </b-col>
                  <b-col cols="col-sm-12 col-md-3 col-lg-3">
                    <b-form-input
                        style="width: 100%; border: 1px solid #c2e7ff;"
                        v-model="apellidoPaterno"
                        placeholder="apellido paterno"
                        type="text"
                        v-on:keypress="esLetra($event)"
                        v-b-tooltip.hover
                        title="Apellido Paterno"
                        v-on:keyup.enter="getPatientsV2()"
                        class="input-buscador"
                    ></b-form-input>
                  </b-col>
                  <b-col cols="col-sm-12 col-md-3 col-lg-3">
                    <b-form-input
                        style="width: 100%; border: 1px solid #c2e7ff;"
                        v-model="apellidoMaterno"
                        placeholder="apellido materno"
                        type="text"
                        v-on:keypress="esLetra($event)"
                        v-b-tooltip.hover
                        title="Apellido Materno"
                        v-on:keyup.enter="getPatientsV2()"
                        class="input-buscador"
                    ></b-form-input>
                  </b-col>
                  <b-col cols="col-sm-12 col-md-1 col-lg-1">
                    <b-button size="sm"
                              v-if="datosCita == null"
                              variant="info"
                              style="margin: auto;"
                              @click="getPatientsV2()">
                      <span ><em class="buscar_svg" style="height: 16px;"></em></span>
                    </b-button>
                    <b-button class="button-dentalia-svg-2 mr-2" variant="primary"
                              title="Quitar tratamiento" style="margin: auto;"
                              @click="cancelarBuscar()"
                              v-if="datosCita!=null">
                      <em class="close_x_svg icon-dentalia-svg-2" style="height: 10px"></em>
                    </b-button>
                  </b-col>
                </b-row>
              </div>

              <div style="min-width: 350px; flex: 1;margin-right: 15px; margin-top: 0px;"
                   :style="datosCita!=null?'width: 100%;margin-left:0px;margin-top:0px':''"
                   v-if="mostrarBarraBusqueda && !checked " >
                <div class="barra" style="margin-top: 10px;" :style="datosCita != undefined && datosCita != null ? 'margin-left:0px; margin-rigth:0px;':''">
                  <div style="flex:1; display: flex;" >
                    <div style="display: contents;">
                        <b-form-input
                            class="input-filter"
                            v-model="nombrePacienteBusqueda"
                            placeholder="Búsqueda de paciente por nombre o ID"
                            type="text"
                            @keydown.enter.prevent="buscarPacientes()"
                        ></b-form-input>

                        <b-button class="button-dentalia-svg-2 mr-2" variant="primary"
                                  title="Ocultar buscador" style="margin: auto;"
                                  @click="cancelarBuscar()"
                                  v-if="datosCita!=null">
                          <em class="close_x_svg icon-dentalia-svg-2" style="height: 10px"></em>
                        </b-button>

                        <b-button size="sm"
                                  v-if="datosCita == null"
                                  variant="info"
                                  :disabled="loadingPacientes || validarInputBusqueda()"
                                  style="margin: auto;"
                                  @click="buscarPacientes()">
                          <span v-if="!loadingPacientes"><em class="buscar_svg" style="height: 16px;"></em></span>
                          <span v-else><b-spinner small></b-spinner></span>
                        </b-button>
                    </div>
                  </div>
                </div>
                <validacion style="font-size: 10px;text-align: center;display: block;"
                            v-if="validarInputBusqueda()"
                            texto="No se pueden buscar letras y numeros al mismo tiempo" />
              </div>

              <b-button-group style="display: flex; margin: auto;">
                <b-button class="button-dentalia-svg-1" variant="primary"
                          title="Mostrar/Ocultar búsqueda"
                          v-if="!mostrarBarraBusqueda &&
                            (idPaciente === undefined || idPaciente === null)"
                          @click="reabrirBusquedaPaciente"
                          style="margin-top: 8px;"
                >
                  <em class="lupa_svg icon-dentalia-svg-1"></em>
                </b-button>

<!--          Segundo botón de buscar ...........               -->
                <b-button class="button-dentalia-svg-1" variant="primary"
                          title="Mostrar/Ocultar búsqueda"
                          v-if="mostrarBarraBusqueda && datosCita!=null &&
                            (idPaciente === undefined || idPaciente === null)"
                          @click="buscarPacientes()"
                          style="margin-top: 8px;"
                >
                  <em class="lupa_svg icon-dentalia-svg-1"></em>
                </b-button>


                <b-button class="button-dentalia-svg-1 ml-2 mt-2" variant="primary"
                          title="Agregar nuevo paciente"
                          v-if="idPaciente === undefined || idPaciente === null"
                >
                  <router-link
                      :to="{ name: 'PacienteCu'  }" >
                    <em class="agregar_usuario_svg icon-dentalia-svg-1"></em>
                  </router-link>

                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!--   MEJORA DEL PATIENT JOURNEY   -->
      <div v-if="datosCalendario !== null && datosCita == null" class="d-flex justify-content-center" style="gap: 12px">
        <span style="font-size: 12px">Doctor: <strong>{{datosCalendario.nombreDoctor}}</strong></span>
        <span style="font-size: 12px">Fecha: <strong>{{datosCalendario.fechaCita | formatoFecha}}</strong></span>
        <span style="font-size: 12px">Hora: <strong>{{ formatearHora(datosCalendario.hora, datosCalendario.minuto) }}  </strong></span>
        <span style="font-size: 12px">Sillón: <strong>{{datosCalendario.sillon}}</strong></span>
      </div>



    <b-row class="mt-3" v-if="registros !== null && mostrarBarraBusqueda">
      <b-col cols="12">

        <div class="detalle-formulario-titulo">
          <span>Pacientes encontrados</span>
        </div>

        <div align="center" v-if="loadingPacientes">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>


        <div class="overflow-auto"  v-if="!loadingPacientes">
          <b-table
              :items="registros"
              :fields="columnasPacientesEncontrados"
              :hover="true"
              :small="true"
              responsive
              fixed
              show-empty
              class="contenedorTablaSinColor"
              @row-clicked="seleccionarPaciente"
          >
            <template v-slot:cell(fechaUltimaCita)="row">
              {{ row.item.fechaUltimaCita | formatoFechaHora }}
            </template>
            <template #cell(idTipoPaciente)="row">
              <b-button v-b-tooltip.hover.left.bottom.v-light
                        :title="'Paciente ' + row.item.tipoPaciente"
                        variant="ligth" size="sm" pill>
              <b-icon font-scale="2" icon="circle-fill"
                      :style="'color: '+row.item.color +'; border:solid 1px gray; border-radius: 50%;cursor:pointer ' "
              ></b-icon>
              </b-button>
            </template>
            <template #empty="scope">
                <b-alert show variant="warning">No hay datos</b-alert>
            </template>
          </b-table>

        </div>

      </b-col>
    </b-row>

    <b-row v-if="registros == null && pacSelTmp == null">
      <b-col cols="12" class="d-flex justify-content-center mt-3">
        <span style="font-size: 12px">Busque el nombre de un paciente para comenzar</span>
      </b-col>
    </b-row>

    <div v-if="datosCita !== null && mostrarComponenteDatosContacto">
      <DatosContactoPaciente :idPaciente="datosCita.idPaciente" :idPacientePadre="datosCita.idPacientePadre" @datosContactoPaciente="recibirContactosPaciente"/>
    </div>
  </b-container>

  </div>
</template>

<script>

import miniToastr from "mini-toastr";
import cardPerfilPaciente from "@/components/NuevaAgenda/nuevaCita/cardPerfilPaciente";
import {DatosCita} from "@/components/NuevaAgenda/nuevaCita/DatosCita";
import DatosContactoPaciente from "@/components/NuevaAgenda/DatosContactoPaciente.vue";

export default {
  name: "busquedaPaciente",
  components: {
    DatosContactoPaciente,
    cardPerfilPaciente,

  },
  props: {
    idPaciente: Number,
    datosCalendario: Object,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    loadingPacientes: false,

    mostrarBarraBusqueda: true,
    nombrePacienteBusqueda: null,

    datosCita: null,

    registros: null,

    mostrarAdvertencia: false,
    pacSelTmp: null,
    checked: false,
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",

    columnasPacientesEncontrados: [
      {key: "id", label: "Id paciente", sortable: true},
      {key: "nombre", label: "Nombre paciente", sortable: true},
      {key: "estatusPTI", label: "PTI", sortable: true},
      {key: "fechaUltimaCita", label: "Fecha última cita", sortable: true},
      {key: "idTipoPaciente", label: "Tipo paciente", sortable: true},
    ],

    lstDatosContactoPaciente: [],
    mostrarComponenteDatosContacto: true
  }),
  watch: {},
  computed: {

  },
  methods: {
    buscarPacientes() {

      if (this.validarInputBusqueda()) {
        console.error("No se puede buscar por validacion de numeros letras")
        return;
      }

      this.pacSelTmp = null;
      this.mostrarAdvertencia = false;

      if (this.loadingPacientes) {
        return;
      }

      this.registros = Array();
      this.paginaActual = 1;
      if (
          this.nombrePacienteBusqueda === undefined ||
          this.nombrePacienteBusqueda === null ||
          this.nombrePacienteBusqueda.length < 4
      ) {
        return;
      }

      const inputTxt = this.nombrePacienteBusqueda
          .trim()
          .toUpperCase();

      this.loadingPacientes = true;
      const parametros = {datoBuscar: inputTxt}
      this.$http
          .post(
              this.$api +
              "paciente/perfiles/buscarPacienteMin", parametros
          )
          .then((response) => {
            if (response.status === 200) {


              if (Array.isArray(response.data.data)) {
                this.registros = response.data.data;

                this.registros.forEach(e => {
                  e.color = e.idTipoPaciente==1?'white':'#00aa33'
                });

                if (Array.isArray(this.registros)) {
                  this.registros.sort(function (a, b) {
                    if (a.id > b.id) {
                      return 1;
                    }
                    if (a.id < b.id) {
                      return -1;
                    }
                    return 0;
                  });
                }
              }
            }
          })
          .catch((error) => {
            miniToastr.info("No se encontraron pacientes");
            console.error("Error", error);
            this.loadingPacientes = false;
          })
          .finally(() => {
            this.loadingPacientes = false;
          });
    },

    getPatientsV2(){
      if ( (this.nombre != undefined && this.nombre.length >= 3) || (this.apellidoPaterno != undefined && this.apellidoPaterno.length >= 3) || (this.apellidoMaterno != undefined && this.apellidoMaterno.length >= 3)) {

        this.$http
            .get(
                this.$api +
                "paciente/perfiles/obtenerDatosPacienteAgenda?nombre=" +
                this.nombre.trim() + "&apellidoPaterno=" + this.apellidoPaterno.trim() + "&apellidoMaterno=" + this.apellidoMaterno.trim()
            ).then((response) => {
          if (response.status === 200) {


            if (Array.isArray(response.data.data)) {
              this.registros = response.data.data;

              this.registros.forEach(e => {
                e.color = e.idTipoPaciente == 1 ? 'white' : '#00aa33'
              });

              if (Array.isArray(this.registros)) {
                this.registros.sort(function (a, b) {
                  if (a.id > b.id) {
                    return 1;
                  }
                  if (a.id < b.id) {
                    return -1;
                  }
                  return 0;
                });
              }
            }
          }
        })
            .catch((error) => {
              miniToastr.info("No se encontraron pacientes");
              console.error("Error", error);
              this.loadingPacientes = false;
            })
            .finally(() => {
              this.loadingPacientes = false;
            });
      }
    },

    esLetra(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character

      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    async seleccionarPaciente(item) {
      this.mostrarComponenteDatosContacto = false;
      this.pacSelTmp = item;

      if (this.datosCita !== undefined && this.datosCita !== null
        && this.datosCita.idPaciente !== undefined && this.datosCita.idPaciente !== null ) {

        this.$swal.fire({
          icon: "warning",
          html: '<strong  style="font-size:14px;"><span>Cambiar paciente eliminará la información actual</span></strong> <br>' +
              ' <br> <h5 style="font-size: 12px;margin-bottom: -20px;"> Si cambia de paciente, perderá la información </h5> ' +
              '<br> <h5 style="font-size: 12px;">ingresada, ¿Desea continuar?</h5>',
          confirmButtonText: "Continuar",
          confirmButtonColor: '#1b81af',
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          showCancelButton: true,
          closeOnClickOutside: false,
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitSelPaciente();
            this.editarDatosContacto();
          }else{
            this.mostrarComponenteDatosContacto = true;
          }
        })
        this.mostrarAdvertencia = true;
        return;
      }else {
        this.submitSelPaciente();
      }


    },

    submitSelPaciente () {
      this.mostrarBarraBusqueda = false;
      this.nombrePacienteBusqueda = null;
      this.registros = null;
      this.pacienteSeleccionado = true;
      this.datosCita = null;
      window.scrollTo(0, 0);

      this.datosCita = new DatosCita();
      this.datosCita.idPaciente = this.pacSelTmp.id;
      this.datosCita.idPacientePadre = this.pacSelTmp.idPacientePadre;
      this.datosCita.nombrePaciente = this.pacSelTmp.nombre;
      this.datosCita.esPacienteNuevo = this.pacSelTmp.idTipoPaciente == 1;
      this.datosCita.idTipoPaciente = this.pacSelTmp.idTipoPaciente;
      this.datosCita.tipoPaciente = this.pacSelTmp.tipoPaciente;
      this.datosCita.idSexo = this.pacSelTmp.idSexo;
      this.datosCita.celular = this.pacSelTmp.telefono;
      this.datosCita.correo = this.pacSelTmp.correo;
      this.datosCita.ptiActivo = this.pacSelTmp.ptiActivo;
      this.datosCita.fechaNacimientoCompleta = this.pacSelTmp.fechaNacimientoCompleta;
      this.datosCita.confianza = this.pacSelTmp.confianza;
      this.datosCita.ultimoTratamiento = this.pacSelTmp.ultimoTratamiento;
      this.datosCita.fechaUltimoTratamiento = this.pacSelTmp.fechaUltimoTratamiento;

      this.datosCita.ultTrataDesde = this.$formatoFechaHace(this.$moment(this.datosCita.fechaUltimoTratamiento));

      this.datosCita.idTagMotivoCita = null;
      this.datosCita.idTratamiento = null;
      this.datosCita.esPacienteVIP = this.pacSelTmp.esPacienteVIP;

      this.$emit('seleccionarPaciente', this.datosCita);

      this.mostrarAdvertencia = false;
      this.mostrarComponenteDatosContacto = true;

      window.scrollTo(0,0)

    },

    async reabrirBusquedaPaciente() {
      this.registros = null;
      this.nombrePacienteBusqueda = null;
      this.mostrarBarraBusqueda = true;
    },

    async cancelarBuscar() {
      this.mostrarBarraBusqueda = false;
    },

    validarInputBusqueda() {
      if (this.nombrePacienteBusqueda !== undefined
          && this.nombrePacienteBusqueda !== null
          && this.nombrePacienteBusqueda !== '') {

        const contieneNumerosLetras =  /[A-Za-z]/.test(this.nombrePacienteBusqueda);
        const contieneNumeros = /[0-9]/.test(this.nombrePacienteBusqueda);
        return contieneNumerosLetras && contieneNumeros;
      }

      return false;
    },

    recibirContactosPaciente(datos){
      this.lstDatosContactoPaciente = datos;
      this.mostrarComponenteDatosContacto = false;
      this.$emit('continuarCita', true);
    },

    editarDatosContacto() {
      this.mostrarComponenteDatosContacto = true;
      this.lstDatosContactoPaciente = [];
      this.$emit("editarDatosContacto");
    },

    formatearHora(hora24, minuto) {
      const hora = parseInt(hora24);
      const min = minuto.toString().padStart(2, '0');
      const ampm = hora >= 12 ? 'pm' : 'am';
      const hora12 = hora % 12 === 0 ? 12 : hora % 12;
      return `${hora12}:${min} ${ampm}`;
    }

  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    if (this.idPaciente !== undefined && this.idPaciente !== null ) {
      this.loadingPacientes = true;
      const parametros = {datoBuscar: this.idPaciente}
      this.$http
          .post(
              this.$api +
              "paciente/perfiles/buscarPacienteMin", parametros
          )
          .then((response) => {
            if (response.status === 200) {
              if (Array.isArray(response.data.data)) {
                this.registros = response.data.data;

                this.registros.forEach(e => {
                  e.color = e.idTipoPaciente==1?'white':'#00aa33'
                });
              }

              this.pacSelTmp = this.registros[0];
              this.submitSelPaciente();

            }
          })
          .catch((error) => {
            miniToastr.info("No se encontró al pacientes");
            console.error("Error", error);
          })
          .finally(() => {
            this.loadingPacientes = false;
          });
    }
  },
}
</script>

<style scoped>

</style>
